module.exports = __webpack_public_path__ + "img/pending.f6615df4.svg";